"use client";

import dynamic from "next/dynamic";
import { useEffect, useRef, useState } from "react";
import { prefersStaticSections } from "@/lib/motion/static-sections";

const EventsTablePreview = dynamic(
  () => import("@/components/home/dashboard/EventsTablePreview"),
  {
    ssr: false,
    loading: () => (
      <div
        className="min-h-[18rem] rounded-2xl bg-background ring-1 ring-foreground/[0.06]"
        aria-hidden
      />
    ),
  },
);

export default function EventsTablePreviewLazy() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (prefersStaticSections()) {
      setShouldLoad(true);
      return;
    }

    const node = containerRef.current;
    if (!node) {
      return;
    }

    if (!("IntersectionObserver" in window)) {
      setShouldLoad(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: "240px 0px" },
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="min-h-[18rem]">
      {shouldLoad ? <EventsTablePreview /> : null}
    </div>
  );
}
